<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <p-table #userRolesGrid
                 [columns]="this.selectedColumns"
                 [value]="roles"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [selection]="selectedUsers"
                 (selectionChange)="onSelectionChange($event)"
                 [paginator]="true"
                 [showFirstLastIcon]="false"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [loading]="loading"
                 [style]="{height: 'calc(100vh - 110px)'}"
                 [(selection)]="selectedUsers">
            <ng-template pTemplate="caption">
                <div class="onboarding-head">
                    <div class="onboarding-head-title">
                        Roles
                    </div>
                    <div class="flex flex-row finance-head-right">
                        <div class="ml-4">
                            <button pButton
                                    icon="pi pi-plus"
                                    class="p-element btn-darkblue p-button p-component"
                                    label="Create Role"
                                    (click)="onCreateRoleClick()"></button>
                        </div>
                        <div class="ml-3 mt-2 mr-2">
                            <column-selector #columnSelector
                                 [defaultColumns]="cols"
                                 (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                 [tableName]="tableName"
                                 [(selectedColumns)]="selectedColumns">
                            </column-selector>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of this.selectedColumns"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon *ngIf="col.showSortIcon" [field]="col.field" class="onboarding-column-sorticon"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-xpressRole let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns" [pSelectableRow]="xpressRole" (click)="handlePopupLinkClick(xpressRole)">
                        {{ xpressRole[col.field] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="roles.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + roles.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<user-managment-roles-details *ngIf="isVisibleRolesDetails"
                              [_visibleDetail]="isVisibleRolesDetails"
                              [_selectedRole]="selectedRole"
                              (changedVisibleDetailEmit)="changedVisibleRolesDetailsEmit($event)">
</user-managment-roles-details>
